import React, { useEffect, useState } from 'react';
import { makeStyles } from '@hummingbirdtechgroup/wings-ui';
const useStyles = makeStyles(({ spacing, palette }) => ({
    banner: {
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: spacing(4),
        width: '100%',
        backgroundColor: `${palette.warning.main}70`,
        fontSize: 16,
        color: 'black',
        zIndex: 1000000000,
        pointerEvents: 'none',
    },
}));
const DEVELOPMENT = 'development';
const STAGING = '.staging.';
const INTEGRATION = '.int.';
function EnvironmentBanner() {
    const classes = useStyles();
    const [deploymentEnv, setDeploymentEnv] = useState(null);
    // @ts-ignore
    const env = process.env;
    useEffect(() => {
        if (window.location.host.includes(INTEGRATION)) {
            setDeploymentEnv('integration');
        }
        else if (window.location.host.includes(STAGING)) {
            setDeploymentEnv('staging');
        }
        else if (env.NODE_ENV === DEVELOPMENT) {
            setDeploymentEnv('development');
        }
    }, []);
    if (!deploymentEnv)
        return null;
    return (React.createElement("div", { className: classes.banner },
        React.createElement("span", null,
            "WARNING: You are on the ",
            React.createElement("b", null, deploymentEnv.toUpperCase()),
            " deployment using the ",
            React.createElement("b", null, env.API_ENV?.toUpperCase()),
            " API/Database")));
}
export default EnvironmentBanner;
//# sourceMappingURL=EnvironmentBanner.js.map